export default function sortByField(arr: any[], field: string) {
  return arr.slice().sort((a, b) => {
    const aValue = a[field] ?? '';
    const bValue = b[field] ?? '';
    
    if (!aValue && !bValue) return 0;

    if (!aValue) return 1;
    if (!bValue) return -1;

    return aValue.localeCompare(bValue);
  });
}
